export type ModoDeEscena = 'animada' | 'final';

/** La única decisión de animar o ir directo al final (spec 344). `webgl` se prueba sólo si hace falta. */
export function decidirModo(e: { menosMovimiento: boolean; webgl: () => boolean }): ModoDeEscena {
  return !e.menosMovimiento && e.webgl() ? 'animada' : 'final';
}

function prefiereMenosMovimiento(): boolean {
  try {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    return true;
  }
}

/** Three r171 dibuja sólo en WebGL 2. El contexto de prueba se suelta enseguida. */
export function hayWebGL(): boolean {
  try {
    const gl = document.createElement('canvas').getContext('webgl2');
    gl?.getExtension('WEBGL_lose_context')?.loseContext();
    return !!gl;
  } catch {
    return false;
  }
}

export const modoDeEscena = (): ModoDeEscena =>
  decidirModo({ menosMovimiento: prefiereMenosMovimiento(), webgl: hayWebGL });

const CUADROS_DE_ARRANQUE = 3;
const CUADROS_MEDIDOS = 20;
const CUADRO_LENTO_MS = 50;

/** Se decide una vez: con los cuadros de arranque (compilan sombreados) más los medidos. */
export function pcLenta(duraciones: readonly number[]): boolean {
  if (duraciones.length !== CUADROS_DE_ARRANQUE + CUADROS_MEDIDOS) return false;
  const total = duraciones.slice(CUADROS_DE_ARRANQUE).reduce((s, d) => s + d, 0);
  return total / CUADROS_MEDIDOS > CUADRO_LENTO_MS;
}
